<template>
  <div class="chat-dashboard">
    <!-- Top Cards Section -->
    <ChatCards :cards="cardsData" />

    <!-- Bar Graph Section -->
    <div class="graph-section">
      <h3>Project Hours Overview</h3>
      <BarGraph :chartOptions="barGraphOptions" />
    </div>

    <!-- First Table Section -->
    <div class="table-section">
      <h3>Projects List</h3>
      <DynamicTable :columns="table1Columns" :data="table1Data" />
    </div>

    <!-- Second Table Section -->
    <div class="table-section">
      <h3>Additional Table</h3>
      <DynamicTable :columns="table2Columns" :data="table2Data" />
    </div>
  </div>
</template>

<script>
import ChatCards from "@/components/ChatCards.vue";
import DynamicTable from "@/components/DynamicTable.vue";
import BarGraph from "@/components/BarGraph.vue";

export default {
  components: {
    ChatCards,
    DynamicTable,
    BarGraph,
  },
  data() {
    return {
      // Cards Data
      cardsData: [
        { title: "Active Projects", value: "825", change: -5.02, icon: "icon-projects" },
        { title: "New Leads", value: "7,522", change: 3.58, icon: "icon-leads" },
        { title: "Total Hours", value: "168h 40m", change: -10.35, icon: "icon-hours" },
      ],

      barGraphOptions: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            displayMode: 'single',
            renderMode: 'auto',
            backgroundColor: '#fff',
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: 'Active',
            data: [23, 24, 18, 25, 27, 28, 25],
            type: 'bar',
            itemStyle: {
              // color: 'red',
            },
          },
          {
            name: 'Non Active',
            data: [26, 24, 18, 22, 23, 20, 27],
            type: 'bar',
            itemStyle: {
              // color: 'green',
            },
          },
          {
            name: 'Live',
            data: [23, 24, 18, 25, 27, 28, 25],
            type: 'bar',
            itemStyle: {
              // color: 'yellow',
            },
          },
        ],
      },

      // First Table Data
      table1Columns: [
        { prop: "name", label: "Project Name" },
        { prop: "status", label: "Status" },
        { prop: "hours", label: "Total Hours" },
      ],
      table1Data: [
        { name: "Project A", status: "Active", hours: "120h" },
        { name: "Project B", status: "Completed", hours: "80h" },
      ],

      // Second Table Data
      table2Columns: [
        { prop: "user", label: "User" },
        { prop: "activity", label: "Activity" },
        { prop: "date", label: "Date" },
      ],
      table2Data: [
        { user: "John Doe", activity: "Logged In", date: "2025-01-01" },
        { user: "Jane Smith", activity: "Logged Out", date: "2025-01-02" },
      ],
    };
  },
};
</script>

<style scoped>
.chat-dashboard {
  padding: 20px;
  background: #f8f9fa;
  color: #212529;
  height: 100%;
  box-sizing: border-box;
}

.graph-section {
  margin-top: 20px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #dee2e6;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h3 {
  margin-bottom: 10px;
  color: #343a40;
}

@media (max-width: 768px) {
  .graph-section {
    padding: 10px;
  }
}
</style>